import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    const isCollectionPage = pathname.startsWith('/collection/');
    const isHomePage = pathname === '/';

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'auto';
    }

    if (isHomePage) {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }

      window.scrollTo(0, 0);
      window.requestAnimationFrame(() => window.scrollTo(0, 0));
      return;
    }

    if (navigationType === 'POP' && isCollectionPage) {
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
